//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox) {
	//@ts-ignore
	const RuleBase = require('../rule')(fox);
	//@ts-ignore
	let registerMemberTplEnv = require('./common/register-member-tplenv');
	//@ts-ignore
	let registerJoinformPrepareApi = require('./guest/register-joinform-prepareapi');
	//@ts-ignore
	let registerPagerSimpleLogged = require('./common/register-pager-simple-tpls');
	//@ts-ignore
	let registerJoinformUpgradeOneclick = require('./guest/register-joinform-upgrade-oneclick');

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			this.freeUserMethod = 'user.upgrade';

			this.originalMap = fox.clone(this.pm.rwom1('@root').getOption('map'), true);
		},

		execute: function () {
			registerJoinformPrepareApi(this);
			registerJoinformUpgradeOneclick(this, fox.Promise);

			return this.super('execute', [this.pm._wom.getRoot()]);
		},

		granted: function (site) {
			var _map = {};

			if (this.pm.member) {
				var memberDl = fox.hydrateDl(this.pm.member);

				registerMemberTplEnv(this, () => memberDl);
				registerPagerSimpleLogged(this, true);

				if (!this.wasChanged) {
					this.pm.wait('@parent .Layout_Home', 'inited', {
						prefix: 'rule_layout_home_banner',
						sync: true
					}).then(resp => {
						resp.performer.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {});
					});
				} else {
					site.wom('~.Widget').forEach(function (widget) {
						widget._templaters = {};
					});

					const home = site.rwom1('.Layout_Home');

					if (home.isActive()) {
						home
							.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {})
							.run();
					} else {
						home.wait('addedToDom').then(_ => {
							home
								.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {})
								.run();
						});
					}
				}

				this.transactioApiMethod = this.freeUserMethod;

				fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map.free'));
			} else {
				registerMemberTplEnv(this, () => false);
				registerPagerSimpleLogged(this);
				
				if (this.wasChanged) {
					site.wom('~.Widget').forEach(function (widget) {
						widget._templaters = {};
					});

					this._destroyBanner(site);
				}

				this.transactioApiMethod = this.guestMethod;

				fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map.guest'));
			}

			site.setOption('map', _map);
		},

		denied: function (site) {
			if (this.wasChanged) {
				this._destroyBanner(site);
			}
		},

		_destroyBanner: function (site) {
			var updateBanner = site.wom1('.Layout_Home #upgradeBanner');

			if (updateBanner) {
				updateBanner.destroy();
				return true;
			}

			return false;
		}
	}, RuleBase, null, 'Rule_Guest');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/guest.es.js